import React from 'react'
import useMedia from 'use-media'

import { Button, ButtonProps, theme } from '@clear/design-system'

const aboveMobile = theme?.breakpoints?.[0] as string

export const BackButton: React.FC<ButtonProps> = (props) => {
  const isAboveMobile = useMedia({ minWidth: aboveMobile })
  const isIconButton = !props.text && props.variant === 'circle'

  if (isIconButton) {
    return (
      <Button
        minHeight="50px"
        minWidth="50px"
        text="Back"
        textProps={{
          display: ['none', 'inline'],
          variant: 'regular',
        }}
        size="small"
        icon="chevron-left"
        iconPosition="left"
        variant="circle"
        data-cy="back"
        data-testid="back"
        color={'#7AA5C1' as never}
        sx={{ outline: '1px #005288 solid' }}
        {...props}
      />
    )
  }

  return (
    <Button
      text="Back"
      textProps={{
        display: ['none', 'inline'],
        variant: 'regular',
      }}
      size={isAboveMobile ? 'large' : 'small'}
      icon="chevron-left"
      iconPosition="left"
      variant="secondary"
      data-cy="back"
      {...props}
    />
  )
}

export const ContinueButton: React.FC<ButtonProps> = ({
  text = 'Continue',
  id,
  ...props
}) => {
  const isAboveMobile = useMedia({ minWidth: aboveMobile })

  return (
    <Button
      text={text}
      id={id}
      textProps={{
        variant: 'regular',
      }}
      size={isAboveMobile ? 'large' : 'small'}
      icon={isAboveMobile ? 'chevron-right' : undefined}
      iconPosition="right"
      data-cy="continue"
      type="submit"
      {...props}
    />
  )
}
